module.exports = __webpack_public_path__ + "static/media/level3.8406d1c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/firebag/level3.png
// module id = 1232
// module chunks = 0